__turbopack_context__.v({
  "arrow": "style-module-scss-module__O4ymZG__arrow",
  "below-the-fold": "style-module-scss-module__O4ymZG__below-the-fold",
});
